import { useContext } from 'react';
import { FetalDeathChartsDataContext } from '../contexts/FetalDeathChartsDataContext';

export const useFetalDeathChartsDataContext = () => {
    return useContext(FetalDeathChartsDataContext);
};
